<span class="file-type {{ value | AutoGenIcon: AUTO_GEN_ICON }}">
  <span>{{ value | AutoGenIcon: AUTO_GEN_ICON }}</span>
</span>
